<template>
  <md-card>
    <md-card-header md-alignment="space-between">
      <h4 class="title">
        <md-icon>assignment</md-icon>교우 참여자
      </h4>
    </md-card-header>
    <md-card-content>

      <div class="table-header-info">
        <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
        <div>
          회원명 <input type="text" style="width:100px;" v-model="memberHnm">
          <md-button class="md-info md-sm" @click="sendQuery()" style="margin-left: 2px; vertical-align: middle;"><md-icon>check</md-icon>검 색</md-button>
        </div>
        <div>
          <select v-model="pagination.perPage" name="pages" @change="perPageChange">
            <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>

      <grid ref="eventMemberJoinerListGrid"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @dblclick="onDbClickExecutive"
            @response="response"
      ></grid>
    </md-card-content>
    <md-card-actions md-alignment="right">
      <md-button class="md-warning md-sm" @click="deleteEventJoiner">
        <md-icon>person_remove</md-icon>참여자에서 제외
      </md-button>
      <md-button class="md-success md-sm" @click="downloadExcel" v-exel-btn="[5,3]" :disabled="this.pagination.total === 0">
        <md-icon>get_app</md-icon>Excel 다운로드
      </md-button>
    </md-card-actions>
  </md-card>
</template>
<script>
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";
import Swal from "sweetalert2";
import moment from "moment";

import { Grid } from '@toast-ui/vue-grid';

export default {
  name: "eventMemberJoinerListComp",
  props: {
    currentDetailMode : {
      type : String,
      default : ''
    },
    modeName : {
      type : String,
      default : ''
    }
  },
  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  watch : {
    'currentDetailMode' (n){
      if(n == this.modeName){
        this.refreshLayout()
      }
    }
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      eventId : null,
      memberHnm : '',
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 2000],
        total: 0
      }
    };
  },
  methods: {
    initGrid() {
      let _this = this;
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_EVENT_JOINER_LIST2, false, this.pagination, ['rowNum','checkbox']);
      this.gridProps['el'] = this.$refs.eventMemberJoinerListGrid;
      this.gridProps['columns'] = [
        {header: '교우번호', name: 'memberNo',align: 'center', sortable: true,
          formatter(value) {
            return `<span style="color:#0091d5; text-decoration:underline; cursor:pointer">${value.value}</span>`;
          }
        },
        {header: '교우명', name: 'memberHnm',align: 'center', sortable: true},
        {header: '교우직위명', name: 'memberorgGbNm',align: 'center', sortable: true},
        {header: '한자명', name: 'memberCnm',align: 'center', sortable: true},
        {header: '대학명', name: 'collegeNm',align: 'center', sortable: true},
        {header: '학과명', name: 'classNm',align: 'center', width:120, sortable: true},
        {header: '졸업회수', name: 'graduationNo',align: 'center', width:80, sortable: true},
        {header: '입학년월', name: 'enterYm',align: 'center', sortable: true},
        {header: '졸업년월', name: 'graduationYm',align: 'center', sortable: true},
        {header: '학번', name: 'hakbun',align: 'center', sortable: true},
        {header: 'seq', name: 'seqNo',align: 'center', hidden:true},
        {header: '메모', name: 'memo',align: 'center',
          editor: {
            type: 'text'
          },
          onAfterChange(e) {
            _this.editRow(e);
          }
        },
        {header: '테이블번호', name: 'tableNo',align: 'center',
          editor: {
            type: 'text'
          },
          onAfterChange(e) {
            _this.editRow(e);
          }
        }
      ];
    },

    editRow (e){
      let targetRow = this.$refs.eventMemberJoinerListGrid.invoke('getRow',e.rowKey);

      let option = {
        eventId : targetRow.eventId,
        memberNo : targetRow.memberNo,
        memberorgGb : targetRow.memberorgGb,
        outjoinerGb : 'N',
        memo : targetRow.memo,
        tableNo : targetRow.tableNo,
        seqNo : targetRow.seqNo
      }

      targetRow.outjoinerGb = 'N';

      if(option){
        let modalOptions = kuaaFnc.getSwalModaloptions();
        kuaaApi.sendServer(
            URL_CONST.UPDATE_EVENT_JOINER,
            targetRow,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `저장 되었습니다.`;
                Swal.fire(modalOptions);
              } else {
                modalOptions.html = `저장 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
        );
      }
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.eventMemberJoinerListGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.refreshLayout();
    },
    refreshLayout (){
      this.$refs.eventMemberJoinerListGrid.invoke("refreshLayout");
    },
    sendQuery(eventId, isInit) {
      if(eventId) this.eventId = eventId;
      if(isInit)  this.memberHnm = null;
      this.$refs.eventMemberJoinerListGrid.invoke("readData", 1, {'eventId':this.eventId, 'outjoinerGb': 'N', memberHnm: this.memberHnm});
    },

    onDbClickExecutive(e) {
      if(e.columnName === "memberNo" && e.instance.getRow(e.rowKey) != null) {
        this.$emit('setExcutiveData', e.instance.getRow(e.rowKey));
        window.open('/Friendship/UpdateMember/' + e.instance.getRow(e.rowKey).memberNo, 'FriendshipUpdateMember');
      }
    },

    downloadExcel() {
      this.pagination.page = 1;
      this.pagination.perPage = this.pagination.total;
      this.pagination.fileName = '교우 참여자';
      this.pagination.eventId = this.eventId;
      this.pagination.outjoinerGb = 'N';
      kuaaApi.requestFileDownload(
          URL_CONST.EVENT_JOINER_EXCEL_DOWNLOAD,
          this.pagination,
          '교우 참여자.xlsx',
          response => {
            this.pagination.page = this.pagination.page;
            this.pagination.perPage = this.pagination.perPage;
          }
      );
    },
    deleteEventJoiner() {

      let modalOptions = {
        type: "warning",
        showCancelButton: false,
        confirmButtonClass: "md-button md-info",
        cancelButtonClass: "md-button md-default",
        confirmButtonText: "확인",
        buttonsStyling: false,
        html : '저장 되었습니다.'
      };

      let checkItems = this.$refs.eventMemberJoinerListGrid.invoke('getCheckedRows');
      if(checkItems.length < 1){
        modalOptions['html'] = '참여자를 선택해 주세요';
        Swal.fire(modalOptions);
        return;
      }

      let params = [];

      checkItems.forEach((obj) => {
        params.push({
          seqNo : obj['seqNo'],
          eventId : this.eventId
        })
      });

      kuaaApi.sendServer(
          URL_CONST.DELETE_EVENT_JOINER2,
          params,
          "post",
          response => {
            console.log("<<<", response);
            modalOptions['html'] = '삭제 되었습니다.';
            Swal.fire(modalOptions);
            this.$emit('refreshJoinerGrid');
            this.sendQuery();
          }
      );
    }
  }
};
</script>

<style lang="css" scoped>
</style>